import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShrinkFattenIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m12 7 5 3.5v5L12 19l-5-3.5v-5z",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 7V3M9 5l3-2 3 2M17 10.5l3.5-2M7 10.5l-3.5-2" }),
		/* @__PURE__ */ _jsx("path", { d: "m12 3 8.5 5.5v7L12 21l-8.5-5.5v-7z" })
	]
});
export default SvgShrinkFattenIcon;
